import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface Props {
  onChange?(values: string[]): void;
}

export function ResultInput({ onChange }: Props) {
  const { t } = useTranslation();
  const allResults = ["Verifiziert", "Abgebrochen", "Fehlgeschlagen", "---"];

  return (
    <Autocomplete
      id="user-search"
      size="small"
      limitTags={1}
      multiple
      onChange={(_, value) => onChange?.(value ?? undefined)}
      fullWidth
      disableCloseOnSelect
      options={allResults}
      renderInput={params => (
        <TextField
          {...params}
          label={t("licenseCheckAdmin.status", "Status")}
          placeholder={t("licenseCheckAdmin.reasonPlaceholder", "Search for verification status")}
        />
      )}
    />
  );
}
